module.exports = __webpack_public_path__ + "static/hero-bg-fc383ff716d80c08384801d02996e29f.jpg";